import { createContext, useContext } from 'react';

import { NAVBAR_MENU_LIST_DEFAULTS_V2 } from './NavbarMenuList.constants';

export interface INavbarMenuListV2Context {
  justify: string;
}

export const NavbarMenuListV2Context = createContext<INavbarMenuListV2Context>({
  justify: NAVBAR_MENU_LIST_DEFAULTS_V2.justify,
});

export function useNavbarMenuListV2Context() {
  const context = useContext(NavbarMenuListV2Context);

  if (!context) {
    throw new Error('useNavbarMenuListV2Context must be used within a NavbarMenuList');
  }

  return context;
}
